import { ComponentRegistry } from './component-registry';
import { Selector } from './types/selector.type';

export function component<T extends string>({
  selector,
  styles,
}: {
  selector: Selector<T>;
  styles?: string;
}) {
  return (target: CustomElementConstructor) => {
    if (styles !== undefined) {
      ComponentRegistry.registerStyles(styles, target);
    }

    ComponentRegistry.register(selector, target);
  };
}
